import React from 'react';
import {connect} from 'react-redux';
import {
    ActionDescriptorsTenderPublicationEvents,
    ActionTenderPublicationEventTypeAdd, ActionTenderPublicationEventTypeDelete,
    ActionTenderPublicationEventTypeEdit
} from "../../../parts/actions";
import ColumnResizer from "react-column-resizer";
import Storege from "../../../storage/storage";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import TenderTypesPublicationEventType from "./TenderPublicationEventTypePopup";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import EditBtn from "../../../parts/EditBtn";


class TenderPublicationEventDescriptorComponent extends CommonTab {

    orderFields = {
        "Tender Publication Event Type Name" : "tenderpublicationeventtypename",
        "Tender Publication Event Type Name Eng": "tenderpublicationeventtypenameeng"
    };

    state = {
        tenderPublicationEvents: {},
        popup: false,
        popupType: undefined,
        rowIndex: -1,
        currentItemIndex: -1,
        order: null
    };

    constructor(props) {
        super(props);
        this.state.tenderPublicationEvents = props.tenderPublicationEvents;
    }

    changeState = (name, e, id) => {
        let temp = this.props.tenderPublicationEvents;
        temp.forEach(function (item) {
            if (item.tenderpublicationeventtypeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            tenderPublicationEvents: Object.assign({}, temp)
        });
    };

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    addContentType = (object) => {
        ActionTenderPublicationEventTypeAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD TENDER PUBLICATION EVENT TYPE',
                item: data
            });
            this.changePopupState();
        });
    };

    editContentType = (object) => {
        ActionTenderPublicationEventTypeEdit(object.tenderpublicationeventtypeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE TENDER PUBLICATION EVENT TYPE',
                item: data,
                id: data.tenderpublicationeventtypeid
            });
            this.changePopupState();
        });
    };

    search = (value) => {
        if (value.length) {
            let filteredArray = this.props.tenderPublicationEvents.filter(item => {
                return item.tenderpublicationeventtypename.toLowerCase().indexOf(value.toLowerCase()) != -1 || item.tenderpublicationeventtypenameeng.toLowerCase().indexOf(value.toLowerCase()) != -1;
            });
            this.setState({
                filtered: true,
                filteredItems: filteredArray
            });
        } else {
            this.setState({
                filtered: false
            });
        }
    };

    render() {
        if (!this.props.tenderPublicationEvents.length) {
            ActionDescriptorsTenderPublicationEvents();
        }
        let {tenderPublicationEvents} = this.props;
        let {filtered, filteredItems} = this.state;
        let list = filtered ? filteredItems : tenderPublicationEvents;
        if (!list) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        this.sortResults(list);
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div className="inline-toolbuttons">
                            <h3>Tender Publication Event Types:</h3>
                            <div className={'tool-bar'}>
                                <ToolButtons
                                    actionType={this.changePopupType}
                                    popupChange={this.changePopupState}
                                    id={this.state.currentItemIndex}
                                />
                                <Search
                                    change={this.search}
                                />
                            </div>
                        </div>
                        <table className='table table-striped'>
                            <thead>
                            {this.orderPanel()}
                            </thead>
                            <tbody>
                            {(list ? list : []).map((item, index) => {
                                return (
                                    <tr key={index} onClick={
                                        e => {
                                            e.preventDefault();
                                            this.setState({
                                                rowIndex: index,
                                                currentItemIndex: item.tenderpublicationeventtypeid
                                            });
                                        }
                                    } className={this.state.rowIndex == index ? 'active' : ''}>
                                        <td className={'flex-row'}>
                                            <RemoveButton
                                                action={ActionTenderPublicationEventTypeDelete}
                                                id={item.tenderpublicationeventtypeid}
                                                descriptor={'REMOVE TENDER PUBLICATION EVENT TYPE'}
                                            />
                                            <EditBtn
                                                actionType={this.changePopupType}
                                                popupChange={this.changePopupState}
                                                change={this.setCurrentIndex}
                                                id={item.tenderpublicationeventtypeid}
                                            />
                                        </td>
                                        <td>{item.tenderpublicationeventtypename}</td>
                                        <ColumnResizer className="columnResizer" minWidth={5}/>
                                        <td>{item.tenderpublicationeventtypenameeng}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.popup ? <TenderTypesPublicationEventType
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        tenderPublicationEvents: state.tenderPublicationEvents
    }
};
const DescriptorTenderPublicationEvent = connect(mapStateToProps)(TenderPublicationEventDescriptorComponent);

export default DescriptorTenderPublicationEvent;